module.exports = __webpack_public_path__ + "static/media/tick-circle-orange.e6dd1464.svg";